import React from 'react'
import { Button } from '../../../components/Button'
import { api } from '../../../services/api'
import { useMutation } from 'react-query'
import { useToast } from '@chakra-ui/react'

async function gerarPix(numeroNota) {
  const res = await api.put('/site/v2/pedido/atualiza-chave-pix', { params: { numero_nota: numeroNota } })

  return res.data
}

export const GerarPix = ({ numeroNota }) => {
  const { mutateAsync, isLoading } = useMutation(gerarPix)

  const toast = useToast({
    position: 'top-right',
    isClosable: true,
  })

  async function handleGerarPix() {
    await mutateAsync(numeroNota, {
      onSuccess: () => {
        toast({
          title: 'Pix gerado com sucesso',
          status: 'success',
        })
      },
      onError: () => {
        toast({
          title: 'Erro ao gerar Pix',
          status: 'error',
        })
      },
    })
  }

  return (
    <Button bgColor="#77dd77" onClick={handleGerarPix} isLoading={isLoading}>
      Gerar Pix
    </Button>
  )
}
